import { useState, useEffect } from "react";
import moment from "moment";
// Constants - Functions
import { primaryColor } from "../../../../../../config/constants";
// Components
import { WeeksContainer, WeekTitle, WeeksAligner, WeekContainer, WeekNumber, WeekImg, CurrentWeekText } from "./styles";
// Assets
import CheckImg from "../../../../../../assets/icons/check.svg";
import LockImg from "../../../../../../assets/icons/lock.svg";

const Weeks = ({
  weeks,
  trainingHasStarted,
  startingDate,
  targetedWeek,
  setTargetedWeek,
  isEditableWeek,
  setIsEditableWeek,
  datesPerWeek,
}) => {
  const [startingWeekDate, setStartingWeekDate] = useState("");
  const [endingWeekDate, setEndingWeekDate] = useState("");

  // Set starting and ending dates of the
  useEffect(() => {
    setStartingWeekDate(moment(datesPerWeek[targetedWeek], "DD-MM-YYYY").format("DD-MM-YYYY"));
    setEndingWeekDate(moment(datesPerWeek[targetedWeek], "DD-MM-YYYY").add(6, "days").format("DD-MM-YYYY"));

    return () => {
      setStartingWeekDate("");
      setEndingWeekDate("");
    };
  }, [startingDate, datesPerWeek, targetedWeek]);

  return (
    <WeeksContainer>
      <WeekTitle>
        <span style={{ fontWeight: "bold" }}>{`Week ${targetedWeek + 1} ${isEditableWeek && trainingHasStarted ? "(current)" : ""}`}</span>{" "}
        | {startingWeekDate} – {endingWeekDate})
      </WeekTitle>

      <WeeksAligner>
        {weeks.map((week) => {
          const isSelected = targetedWeek === week;
          const trainingNotStartedYetFirstWeek = !trainingHasStarted && week === 0;
          const today = moment();

          const isPreviousWeek = () => {
            const currentWeek = moment(datesPerWeek[week], "DD-MM-YYYY");
            return currentWeek.isBefore(today, "day");
          };

          const isCurrentWeek = () => {
            const startingCurrentWeek = moment(datesPerWeek[week], "DD-MM-YYYY");
            const endingCurrentWeek = moment(datesPerWeek[week], "DD-MM-YYYY").add(6, "days");
            return (
              trainingNotStartedYetFirstWeek ||
              (today.isSameOrAfter(startingCurrentWeek, "day") && today.isSameOrBefore(endingCurrentWeek, "day"))
            );
          };

          const handleSetWeek = () => {
            setTargetedWeek(week);
            setIsEditableWeek(isCurrentWeek());
          };

          return (
            <WeekContainer
              key={week}
              onClick={handleSetWeek}
              borderRight={week + 1 < weeks.length}
              pointerEvents={isPreviousWeek() || isCurrentWeek() ? "auto" : "none"}
            >
              <WeekNumber isSelected={isSelected} color={isCurrentWeek() ? "#F15A24" : isPreviousWeek() ? primaryColor : "#C8C8C8"}>
                Week {week + 1}
              </WeekNumber>
              {!trainingHasStarted && isCurrentWeek() ? null : isCurrentWeek() ? (
                <CurrentWeekText>(current)</CurrentWeekText>
              ) : (
                <WeekImg src={isPreviousWeek() ? CheckImg : LockImg} alt="week-ico" />
              )}
            </WeekContainer>
          );
        })}
      </WeeksAligner>
    </WeeksContainer>
  );
};

export default Weeks;
